import React, { useState } from "react";
import { FaLightbulb, FaTable, FaChartLine } from "react-icons/fa";
import ArchiveTableModal from "../../components/Archive/ArchiveTableModal";
import ArchiveChartModal from "../../components/Archive/ArchiveChartModal";
import styles from "./Monitor.module.css";

const isActiveValue = (value) => {
  return (
    value === true ||
    value === 1 ||
    value === "1" ||
    value === "true" ||
    value === "TRUE" ||
    value === "on" ||
    value === "ON"
  );
};

const hasValue = (value) => {
  return (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    value !== "--" &&
    value !== "---" &&
    value !== "N/A" &&
    value !== "nan" &&
    value !== "NaN"
  );
};

const getCustomName = (customNames, index) => {
  if (!customNames) return "";

  const name = customNames[index] ?? customNames[String(index)];

  if (name === undefined || name === null || String(name).trim() === "") {
    return "";
  }

  return String(name).trim();
};

const getSensorColor = (type) => {
  switch (type) {
    case "temp":
      return "#ff6b6b";
    case "humi":
      return "#4dabf7";
    case "wind":
      return "#cbd5e0";
    default:
      return "#ffffff";
  }
};

const getLimitValue = (data = {}) => {
  const settings = data.settings || {};

  return (
    settings.setpoint ??
    settings.setPoint ??
    settings.set_point ??
    data.setpoint ??
    data.setPoint ??
    data.set_point ??
    data.limit ??
    data.threshold ??
    ""
  );
};

const getLimitLabel = (limitValue, unit) => {
  if (!hasValue(limitValue)) {
    return "حد: ---";
  }

  return `حد: ${limitValue}${unit ? ` ${unit}` : ""}`;
};

const SensorMonitorCard = ({
  type,
  index,
  label,
  icon,
  unit,
  data,
  customNames = {},
  serial,
  token,
}) => {
  const [isArchiveOpen, setIsArchiveOpen] = useState(false);
  const [isChartOpen, setIsChartOpen] = useState(false);

  if (!data) return null;

  const { current, value, triggered } = data;

  const displayValue = hasValue(current) ? current : value;
  const isTriggered = isActiveValue(triggered);

  const customName = getCustomName(customNames, index);
  const displayName = customName || label;
  const displayTitle = customName ? `${customName} - ${label}` : label;

  const sensorColor = getSensorColor(type);
  const sensorKey = `${type}${index}`;

  const limitValue = getLimitValue(data);
  const limitLabel = getLimitLabel(limitValue, unit);

  return (
    <div className={`${styles.sensorCard} ${styles.monitorOnlyCard}`}>
      <div className={`${styles.cardHeader} ${styles.sensorMonitorHeader}`}>
        <div className={styles.sensorMonitorHeaderMain}>
          <div className={styles.sensorMonitorTitleBlock}>
            <div className={styles.sensorMonitorTitleTop}>
              <span className={styles.sensorMonitorMainIcon}>{icon}</span>

              <span
                className={`
                                    ${styles.sensorMonitorCustomName}
                                    ${!customName ? styles.cardDisplayNameDefault : ""}
                                `}
                title={displayTitle}
              >
                {displayName}
              </span>
            </div>

            <div className={styles.sensorMonitorInlineActions}>
              <button
                type="button"
                className={styles.monitorActionBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsArchiveOpen(true);
                }}
                title="مشاهده آرشیو جدولی"
              >
                <FaTable />
              </button>

              <button
                type="button"
                className={styles.monitorActionBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsChartOpen(true);
                }}
                title="مشاهده نمودار"
              >
                <FaChartLine />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.sensorMonitorValueBox}>
        <div
          className={styles.sensorMonitorValue}
          style={{
            color: sensorColor,
            direction: "ltr",
            unicodeBidi: "isolate",
          }}
        >
          <span>{hasValue(displayValue) ? displayValue : "--"}</span>

          {unit && <span className={styles.sensorMonitorUnit}>{unit}</span>}
        </div>

        <div className={styles.sensorMonitorLabel} title={limitLabel}>
          {!hasValue(limitValue) ? (
            "حد: ---"
          ) : (
            <>
              <span>حد: </span>

              <span
                style={{
                  direction: "ltr",
                  unicodeBidi: "isolate",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <span>{limitValue}</span>
                {unit && <span>{unit}</span>}
              </span>
            </>
          )}
        </div>
      </div>

      <FaLightbulb
        className={`
                    ${styles.cardTrigCorner}
                    ${isTriggered ? styles.cardTrigCornerOn : styles.cardTrigCornerOff}
                `}
        title={isTriggered ? "Trig فعال" : "Trig غیرفعال"}
      />

      <ArchiveTableModal
        isOpen={isArchiveOpen}
        onClose={() => setIsArchiveOpen(false)}
        serial={serial}
        sensorKey={sensorKey}
        title={displayTitle}
        token={token}
      />

      <ArchiveChartModal
        isOpen={isChartOpen}
        onClose={() => setIsChartOpen(false)}
        serial={serial}
        sensorKey={sensorKey}
        title={displayTitle}
        unit={unit}
      />
    </div>
  );
};

export default SensorMonitorCard;
